
const arTranslations = {
  "welcome": "أهلا بك",
  "workingHours": "ساعات العمل",
  "today": "اليوم",
  "clockIn": "تسجيل الحضور",
  "clockOut": "تسجيل الإنصراف",
  "location": "موقع",
  "inbox": "صندوق الوارد",
  "seemore": "شاهد المزيد",
  "totalworkforce":"إجمالي القوى العاملة",
  "attendancestatus" : "حالة الحضور",
  "clockedinfromoffice" : "تم تسجيل الدخول من المكتب",
  "clockedinfromremote" : "تم تسجيل الدخول عن بعد",
  "notyetclockedin" : "لم يتم تسجيل الدخول بعد",


  "inboxItems": {
    "item1": "وثيقة ذكية",
    "item2": "دقائق الاجتماع",
    "item3": "اجتماع",
    "item4": "مهامي",
    "item5": "الخدمات الذكية",
  },
  "mostusedservice": "لخدمات الأكثر استخداما",
  "mostusedItem": {
   "item1": "الخدمات الذكية", 
    "item2": "تقويم الاجتماع",
    "item3": "المهام"
  },
  "knowledgehub": "مركز المعرفة",
  "knowledgeItem": {
    "item1": "دليل الموظف",
    "item2": "مجلد مشترك",
    "item3": "روابط وفيديوهات",
    "item4": "تقريري",
    "item5": "أصولي",
    "item6": "مجموعات"
  },


  "allmytasks": "كل مهامي",
  "notask": "لا توجد مهام",
  "mytaskcard": "بطاقة المهام الخاصة بي",
  "entertasktitle" : "أدخل عنوان المهمة",
  "entertaskdescription" : "أدخل وصف المهمة",
  "taskname": "اسم المهمة",
  "projectname": "اسم المشروع",
  "assignedBy": "تم التعيين من قبل",
  "assignedto": "مُسند إلى",
  "duedate": "تاريخ الاستحقاق",
  "knowmore" : "معرفة المزيد",
  "todaymeeting" :"اجتماع اليوم",
  "today'stasks" : "مهام اليوم",
  "meetingforToday": "اجتماع لهذا اليوم",
  "mymeeting": "اجتماعي",
  "yourschedulefortheday":"جدولك لليوم",
 "Itlookslikeyoudon'thaveanymeetingsscheduledatthemoment" : " لا يبدو أن لديك أي اجتماعات مجدولة في الوقت الحالي.",
  "Itlookslikeyoudon'thaveanytasksassignedtoyourightnow.":"يبدو أنه لا توجد أي مهام مخصصة لك في الوقت الحالي.",
  "thetasksassignedtoyoufortoday":" المهام المخصصة لك لليوم",
  "recentprojects" : " المشاريع الأخيرة",
  "theprojectsassignedtoyou": "المشاريع المخصصة لك",
  "totalavailableleave": "إجمالي الإجازات المتاحة",
  "period" : "الفترة الزمنية",
  "review" : "مراجعة",
  "entermeetingtitle" : "أدخل عنوان الاجتماع",
   "entermeetingagenda":"أدخل أجندة الاجتماع",
   "chooseemployee" : "اختر الموظف",
   "externalpeople" : "أشخاص خارجيون",
"exteranlpeopleemail" : "البريد الإلكتروني للأشخاص الخارجيين",
"agenda" : " جدول الأعمال",
"joinmeet" : "انضمام",
"entermeetinglocation" : "أدخل موقع الاجتماع",
"entermeetinglink" : " أدخل رابط الاجتماع",
"selectmeetingnotestaker" : "اختر كاتب ملاحظات الاجتماع",
"meetinglink" : "رابط الاجتماع",
  "meetingName": "اسم الاجتماع",
  "meetingdatetime": "تاريخ ووقت الاجتماع",
  "meetingloc": "موقع الاجتماع",
  "meetingorg": "منظم الاجتماع",
  "momcreator": "موم الخالق",
  "assignedTask": "المهام المعينة",
  "assignto": "يسند إلى",
  "assignby": "أسند بواسطة",
  "empOverview": "نظرة عامة على الموظفين",
  "priority": "أولوية",
  "completed": "المكتملة",
  "inprogress": "في تَقَدم ",
  "confirmurPart": "تأكيد مشاركتك",
  "yes": "نعم",
  "no": "لا",
  "mayBe": "ربما",
  "attendees": "الحاضرين",
  "notesTaker": "مدون الملاحظات",


  "contentItems": {
    "item0": "لوحة القيادة",
    "item1": "الحضور الذكي",
    "item2": "الخدمات الذكية",
    "item3": "طلب",
    "item4": "تقويم الاجتماع",
    "item5": "المشروعات",
    "item6": "المهام",
    "item7": "وثيقة ذكية",
    "item8": "دقائق الاجتماع",
    "item9": "تقرير الرواتب",
    "item10": "تقريري",
    "item11": "مجلد مشترك",
    "item12": "روابط وفيديوهات",
    "item13": "دليل الموظف",
    "item14": "مجموعات",
    "item15": "أصولي",
    "item16": "ملاحظة منظمة العفو الدولية",
    "item17": "محرك المستندات بالذكاء الاصطناعي",
    "item18": "بوت",
    "item19": "لتعرف الضوئي على الحروف والمسح الضوئي",
    "item20": "محادثة",
    "item21": "دعم تكنولوجيا المعلومات الذكية",
    "item24" : "شريط الإعلان",
    "item25" : "مولد قوات الدفاع الشعبي",
    "contentItems": {
      "dashboard": "لوحة تحكم الرئيس التنفيذي"
    },
      "item22":"WebRTC",
    "item23":"عطلة"
  },

 
  "ceoInboxItem": {
    "item1": "دقائق الاجتماع",
    "item2": "وثيقة ذكية",
    "item3": "الخدمات الذكية",
  },

  "hrproduct": "الموارد البشرية والإنتاجية",
  "advanceai": "الذكاء الاصطناعي المتقدم",
  "newDoc": "مستند جديد",
  "dashboard": "لوحة تحكم الرئيس التنفيذي",
      "viewPdf": "عرض PDF",
    "viewPdfMom": "عرض PDF محضر الاجتماع",
      "tasksDetails": "تفاصيل المهام",
 "viewDocuments": "عرض المستندات",
 "editProjects": "تعديل المشاريع",
 "notifications": "الإشعارات",
 "itSupport": "دعم تكنولوجيا المعلومات",
 "chatBot": "الدردشة الآلية",
   "viewRequest": "عرض الطلب",




  "titless": {
    "inbox": "صندوق الوارد",
    "sentItems": "العناصر المرسلة",
    "archive": "الأرشيف",
    "allDocuments": "جميع المستندات",
    "viewMore": "عرض المزيد",
    "draft": "مسودة",
    "cc" : "نسخة إلى",
    // request
    "Approved": "موافق عليه",
    "allrequest": "كل طلب",
    "pending":"معلق",
    "rejected": "مرفوض",
    "allmom": "كل أمي",
  },
// task 
  "titles": {
    "allTask": "جميع المهام",
    "inProgressTask": "المهام قيد التنفيذ",
    "completedTask": "المهام المكتملة",
    "pendingTask": "المهام المعلقة",
    "overAllTask": "المهام الإجمالية",
    "justin": "فقط في",
  },

  "task": "مهامي",
  "alltask": "جميع المهام",
  "newtasks": "مهمة جديدة",
  "overalltask": "المهمة الشاملة",
  "createTask": "إنشاء مهمة",
  "viewMore": "عرض المزيد",

  // Project
  "titlesss": {
    "allProject": "جميع المشاريع",
    "inProgress": "قيد التنفيذ",
    "completed": "المكتملة",
    "pending": "معلق",
    "hold": "في الانتظار"
  },

  // itsupport
  "titlessss": {
    "openTickets": "التذاكر المفتوحة",
    "inProgress": "قيد التنفيذ",
    "closed": "مغلق",
    "allTickets": "جميع التذاكر",
    "resolved" : "تم الحل"
  },

  "titlesssss": {
    "attendance": "حضور",
    "meeting": "اجتماعات",
    "task": "المهام",
    "request": "طلب",
    "document": "وثائق",
  },

  // {Payroll}
  "translate" :{
    "payroll": "الراتب",
    "payrollDashboard": "لوحة الرواتب",
    "payrollDetails" : "تفاصيل الرواتب",
    "choosepayrollPeriod":"اختر فترة الرواتب",
    "PayrollReport" : "تقرير الرواتب",
    "payrollsummary":"ملخص الرواتب",
    "chooseperiod" : " اختر الفترة",
    "choosepayrollperiod" : "اختر فترة الرواتب"

  },
  "reopen" : "إعادة الفتح" ,
  "payrollDashboard": "لوحة الرواتب",
  "payrollDetails" : "تفاصيل الرواتب",
      "botHistory": "تاريخ الروبوت",
    "viewHoliday": "عرض العطلة",
    "viewDocument": "رض المستند",
    "signDocument": "توقيع المستند",
    "reviewDocument": "مراجعة المستند",
    "chartingAndDiagramming": "الرسم البياني والمخططات",
    "selectChartType": "اختر نوع المخطط",
    "describeChart": "صف المخطط الذي تريد إنشاؤه",
      "getCode": "احصل على الشيفرة",
  "mermaidCode": "شيفرة Mermaid",
    "enterChartDescription": "أدخل وصف المخطط",
    "generatedImage": "الصورة المُولدة",
    "mermaidCodeWillAppearHere": "سيظهر كود Mermaid هنا",
    "downloadImage": "تحميل الصورة",
    "noChatHistory": "لا يوجد سجل محادثات لهذا المستخدم",
    "timestamp": "الطابع الزمني",


  "commands": "الأوامر",
  "postCommand": "نشر الأمر",
  "markAsCompleted": "وضع علامة كمكتمل",
  "markAsInProgress": "وضع علامة قيد التنفيذ",
  "backToInProgress": "العودة إلى قيد التنفيذ",
  "backToInitiated": "العودة إلى تم البدء",
  "createdBy": "تم الإنشاء بواسطة",
  "allProject": "جميع المشاريع",
  "viewProjects": "عرض المشاريع",


  "RejectDocumentDesk": "رفض مكتب المستندات",
  "ApproveDocumentDesk": "الموافقة على مكتب المستندات",
  "ArchiveDocument": "أرشفة المستند",
  "ApproveDocument": "الموافقة على المستند",
  "Approve": "موافقة",
  "RejectDocument": "رفض المستند",
  "extractedText" : "النص المستخرج",
  "askAnythingGetAnswer": "اسأل أي شيء واحصل على إجابتك",

  "copy" : "نسخ",
  "addAnnouncement": "إضافة إعلان",
  "announcementDetails": "تفاصيل الإعلان",
  "editEmployee": "تعديل الموظف",
  "createEmployee": "إنشاء موظف",
  "employeeDetails": "تفاصيل الموظف",
  "meetingDetails": "تفاصيل الاجتماع",
  "profileDetails": "تفاصيل الملف الشخصي",
  "changePassword": "تغيير كلمة المرور",
  "taskDetail": "تفاصيل المهمة",
  "mom": "محضر الاجتماع",
  "addMom": "إضافة محضر الاجتماع",
  "createMom": "إنشاء محضر الاجتماع",
  "createWorkflow": "إنشاء سير العمل",
  "viewMom": "عرض محضر الاجتماع",
  "signMom": "توقيع محضر الاجتماع",
  "pdfMom": "محضر الاجتماع PDF",
  "viewAssets": "عرض الأصول",
  "groupInfo": "معلومات المجموعة",
  "wfrRequest": "طلب WFR",
  "editRequest": "تعديل الطلب",
  "leaveHistory": "تاريخ الإجازات",
 "viewSmartService": "عرض الخدمة الذكية",

  "createTeam": "إنشاء فريق",
  "approverNotes": "ملاحظات الموافق",
  "copied" : "تم النسخ",
  "smartSupport": "دعم تكنولوجيا المعلومات الذكية",
  "projects": "المشروعات",
  "myprojectcard": "بطاقة مشروعي",
  "pleaseSelectLeaveTypes": "يرجى اختيار أنواع الإجازات",
  "description": "وصف",
  "projmanager": "مدير المشروع",
  "teammembers": "أعضاء الفريق",
  "startdate": "تاريخ البدء",
  "enddate": "انتهاء العرض",
  "duration": "مدة",
  "noproject": "لا يوجد مشاريع!!",
  "createproj": "إنشاء مشروع",
  "employeeId": "الرقم الشخصي للموظف",
  "dateofjoin": "تاريخ الانضمام",
  "qualification": "مؤهل",
  "supervisor": "مشرف",
  "annuallevbal": "رصيد الإجازة السنوية",
  "annualsickbal": "رصيد الإجازات المرضية السنوية",
  "theme": "السمة",
  "changePass": "تغيير كلمة المرور",
  "logOut": "تسجيل خروج",
  "public": " عام",
  "private": "خاص",
  "newproject": "مشروع جديد",
  "shareFolder": "مجلد مشترك",
  "newfolder": "ملف جديد",
  "noMeetings": "لا توجد اجتماعات",
  "meeting": "الاجتماعات",
  "smartDocument": "وثيقة ذكية",
  "goBack": "الرجوع للخلف",
  "back": "للخلف",
  "minutesofMeeting": "دقائق الاجتماع",
  "newMom": "أمي جديدة",
  "createmeet": "إنشاء اجتماع",
  "attendanceRep": "تقرير الحضور",
  "smartService": "الخدمات الذكية",
  "waitingforapproval" :"في انتظار الموافقة",
  "selectmonth" : "اختر الشهر",
  "currentmonth" : "الشهر الحالي",
  "previousmonth" : "الشهر السابق",
  "lastthreemonth" : "آخر ثلاثة أشهر",
  "custom" : "مخصص",
  "generatereport" : "إنشاء تقرير",
  "approvedat" : "تمت الموافقة في",
  "rejectedat" : "تم الرفض في",
  "pending": "قيد الانتظار",
  "forapproval": "للموافقة",
  "approved": "موافق عليه",
  "rejected": "مرفوض",
  "reject": "يرفض",
  "request": "طلب",
  "norequestsubmitted" : "لم يتم تقديم أي طلب!",
  "Itsallclear" : "كل شيء واضح حتى الآن. أضف شيئًا جديدًا لملء هذه المساحة.",
  "newrequest": "طلب جديد",
  "requestLeave": "طلب-إجازة",
  "requestSickleave": "طلب-إجازة مرضية",
  "requestworkfromRemote": "طلب العمل عن بعد",
  "selectclockintime" : "اختر وقت تسجيل الدخول",
  "selectrequest" : "اختر الطلب",
  "selectclockinlocation": "اختر موقع تسجيل الدخول",
  "selectclockouttime" : "اختر وقت تسجيل الخروج",
  "selectclockoutlocation" : "اختر موقع تسجيل الخروج",
  "selectdate" :"​حدد التاريخ​",
  "requesttype" : "نوع الطلب",
  "halfday" : "نصف يوم",
  "leavecategory" : "فئة الإجازة",
  "fromdate": "من التاريخ",
  "todate": "إلى التاريخ",
  "selectfromdate" : "اختر تاريخ البدء",
  "selecttodate": "اختر تاريخ الانتهاء",
  "enterreason" : "أدخل السبب",
  "noSignatureAvailable": "لا توجد توقيع متاح.",
  "others": "آخر..",
  "casual": "غير رسمي",
  "fullday": "يوم كامل",
  "shortLeave": "إجازة قصيرة",
  "sick": "مريض",
  "leaverequest": "طلب الإجازة",
  "close": "يغلق",
  "requestSubmitSucces": "تم تقديم الطلب بنجاح!",
  "selectcategory": "حدد الفئة",
  "docSelected": "تم تحديد المستند",
  "*documentisMandatory": "* الوثيقة إلزامية للإجازة المرضية أكثر من يومين",
  "reason": "سبب",
  "approver": "موافق",
  "starttime": "وقت البدء",
  "endtime": "وقت النهاية",
  "newservice": "خدمة جديدة",
  "createmom": "خلق أمي",
  "edit":"يحرر",
  "date": "التاريخ",
  "inprogressProj": "مشروع قيد التقدم",
  "cancelmeet": "إلغاء الاجتماع",
  "nodocument": "لا توجد مستندات",
  "document": "وثيقة",
  "reviewed": "تمت مراجعته",
  "view": "منظر",
  "docHistory": "تاريخ الوثيقة",
  "relatedAttach": "المرفقات ذات الصلة",
  "relateddoc" : "الوثائق ذات الصلة",
  "relatedmeet" : "الاجتماعات ذات الصلة",
  "relatedtasks" : "المهام ذات الصلة",
  
  "docComment":"تعليقات الوثيقة",
  "shareFolderView": "عرض المجلد المشترك",
  "upload": "رفع",
  "uploaddocument" : "تحميل المستند",
  "Formatpdf" : "​يجب أن يكون التنسيق بصيغة .pdf أو .jpeg أو .png وأقل من 5 ميجابايت",
  "Formatpdf2" : "​يجب أن يكون التنسيق بصيغة .pdf أو .doc أو .word وأقل من 5 ميجابايت",


  "linksandvideos": "الروابط ومقاطع الفيديو",
  "newlinkvideo": "رابط جديد وفيديو",
  "empDirectory": "دليل الموظفين",
  "groupteam": "المجموعة / الفريق",
  "createGroup": "إنشاء مجموعة",
  "assets": "أصول",
  "searchassets" : "ابحث عن الأصول",
  "assetname" : "اسم الأصل",
  "assetsinfo" : "معلومات الأصل",
  "devicename" : "اسم الجهاز",
  "brand" : "العلامة التجارية",
  "enterserialnumber" : "أدخل الرقم التسلسلي",
  "enterproductname" : "أدخل اسم المنتج",
  "enterproductvalue" :"أدخل قيمة المنتج",
  "createAsset": "إنشاء الأصول",
  "AInotes": "ملاحظات الذكاء الاصطناعي",
  "AIPDFGenerator" : "مولد PDF بالذكاء الاصطناعي",
  "startSpeaking": "اضغط على الزر وابدأ في التحدث",
  "listening": "يستمع",
  "notListening": "لا يستمع",
  "smartitSupport": "دعم تكنولوجيا المعلومات الذكية",
  "allTask": "جميع المهام",
  "ticketDetails": "تفاصيل التذكرة",
  "openTickets": "التذاكر المفتوحة",
  "open" : "مفتوح",
  "closed": "مغلق",
  "allTickets": "جميع التذاكر",
  "tickets": "التذاكر",
  "noTickets": "لا تذاكر",
  "createTickets": "إنشاء التذاكر",
  "updateChart": "تحديث المخطط",
  "remark": "ملاحظة",
  "remarkCannotbeempty": "لا يمكن أن تكون الملاحظة فارغة",
  "newTicket": "تذكرة جديدة",
  "attachments": "المرفقات",
  "title": "العنوان",
  "browse": "تصفح",
  "cancel": "إلغاء",
  "submit": "إرسال",
  "addTickets": "إضافة تذاكر",
  "noFiles": "لا توجد ملفات",
  "newMeeting": "اجتماع جديد",
  "newemployee": "موظف جديد",
  "ocrscan": "الماسح الضوئي للتعرف الضوئي على الحروف",
  "camera": "آلة تصوير",
  "gallery": "معرض",
  "capture": "يأسر",
  "subject": "الموضوع",
  "agenda": "جدول الأعمال",
  "repeat": "التكرار",
  "everyMonday": "كل يوم إثنين",
  "everyTuesday": "كل يوم ثلاثاء",
  "everyWednesday": "كل يوم أربعاء",
  "everyThursday": "كل يوم خميس",
  "everyFriday": "كل يوم جمعة",

  "noteTaker": "مدون ملاحظات",
  "link": "وصلة",
  "time": "الوقت",
  "from": "من",
  "to": "إلى",
 
  "send": "إرسال",
  "Position": "موضع",

  "searchemployee" : "ابحث عن موظف",
  "entertitle" : "أدخل العنوان",
  "enterdescription" : "أدخل الوصف",
  "access" : "وصول",
  "enterlink" : "أدخل الرابط",
  "norecordsfound" : "لم يتم العثور على سجلات",
  "Selectanemployeetoviewtheirdetails" : "اختر موظفًا لعرض تفاصيله",
  "leavequotanotassigned" : "لم يتم تخصيص حصة الإجازة",
  "sharecontact" : "مشاركة جهة الاتصال",
  "leavequota" : "حصة الإجازة",
  "updateleavequota" : "تحديث حصة الإجازة",
  "groupname"  : "اسم المجموعة",   
  "pressthebutton" : "اضغط على الزر لبدء التحدث",
  "typeyourmessage" : "...اكتب رسالتك",
   "raiseddate" : "تاريخ الطرح",
   "raisedby" : "تم الطرح بواسطة",
   "requestercomments" : "تعليقات مقدم الطلب",
   "writecomments" : "اكتب تعليقات",
   "listeningvoice" : "استماع للصوت",
   "speechhistory" : "تاريخ الكلام",
   "Nospeechhistoryavailable" : "سجل الكلام غير متوفر",
   "typing" : "كتابة...",
   "askanything" : "اسأل أي شيء، وستحصل على إجابتك",
   "ticketreview" : "مراجعة التذكرة",
   "markasclosed" : "وضع علامة كمغلق",

   "NoPDFContent": "لا يوجد محتوى PDF متاح",
   "Back": "رجوع",
   "MobileViewingMessage": "لتحسين العرض على الأجهزة المحمولة:",
   "OpenPDF": "فتح PDF",
   "DownloadPDF": "تحميل PDF",
   "YourSignature": "توقيعك:",
   "ClearSignature": "مسح التوقيع",
   "EnterYourComments": "أدخل تعليقاتك",


  "holiday" : "عطلة",
  "addholiday" : "إضافة عطلة",
  "publicholiday" : "عطلة رسمية",
  "companyholiday" : "عطلة الشركة",
  "publishdate" : "تاريخ النشر",
  "selectpublishdate" : "اختر تاريخ النشر",
  "enterannouncementtitle" : "أدخل عنوان الإعلان",
  "enterannouncementdescription" : "أدخل وصف الإعلان",
  "leavetype" : "نوع الإجازة",
  "selectleavetype" : "اختر نوع الإجازة",
  "selectoffice" : "اختر المكتب",
  "actionPlan": "خطة عمل",
  "linkedproject": "مشروع مرتبط",
  "high": "عالي",
  "medium": "متوسط",
  "low": "قليل",
  "assignTask": "تعيين المهمة",
  "workFlow": "تدفق العمل",
  "projtitle": "عنوان المشروع",
  "enterprojecttitle" : "أدخل عنوان المشروع",
  "enterprojectdescription" : "أدخل وصف المشروع",
  "projectmanager" : "مدير المشروع",
  "nameoftheclient" : "اسم العميل",
  "selecttechstack" : "اختر مجموعة التقنيات",
  "clientname": "اسم العميل",
  "techStack": "المكدس الفني",
  "create": "يخلق",
  "nameTeamMembers": "اسم أعضاء الفريق",
  "nameProjManager": "إسم مدير المشروع",
  "id": "بطاقة تعريف",
  "reviewedby": "تمت مراجعته بواسطة",
  "signby": "وقع من طرف",
  "Documentid" : "معرّف المستند",
  "reviewer" : "مُراجع",
  "preparedby": "أعده",
  "selectproject" : "اختر المشروع",
  "selectemployee": "اختر الموظف",
  "search" : "...بحث",
  "files" : "ملفات",
  "purpose" : "غرض",
  "discussionpoints" : "نقاط المناقشة",
  "choosepurpose" : "اختر الغرض",
  "employee": "موظف",
  "team": "فريق",
  "member": "عضو",
  "cc": "نسخة",
  "save": "حفظ",
  "editmeeting": "تحرير الاجتماع",
  "selectedEmployees": "الموظفين المختارين",
  "selectEmployees": "حدد الموظفين",
  "assignEmployees": "تعيين الموظفين",
  "employees": "الموظفين",
  "noactionreq": "👍لا يلزم اتخاذ أي إجراء ",
  "updateMeeting": "اجتماع التحديث",
  "UpdateProject": "تحديث المشروع",
  "progress": "تقدم",
  "inProgress": "قيد التنفيذ",
  "deadline" : "الموعد النهائي",
  "completed": "المكتملة",
  "pending": "معلق",
  "hold": "في الانتظار",
  "update": "تحديث",
  "editTask": "تحرير المهمة",
  "through": " من خلال",
  "forInfo": "للحصول على معلومات",
  "forAction": "للعمل",
  "forApprove": "للموافقة",
  "preview": "معاينة",
  "newSharedFolder": "مجلد مشترك جديد",
  "whocanacess": "من يستطيع الوصول",
  "newLink&Video": "رابط وفيديو جديد",
  "newTeam": "فريق جديد",
  "groupName": "اسم المجموعة",
  "newAssets": "الأصول الجديدة",
  "serialno": "الرقم التسلسلي",
  "productname": "اسم المنتج",
  "productvalue": "قيمة المنتج",
  "smartAttendance": "الحضور الذكي",
  "viewallemp": "عرض جميع الموظفين",
  "report": "تقرير",
  "attendancereport": "تقرير الحضور",
  "norequest": "لا طلبات",
  "initiated": "بدأ",
  "users": "المستخدمين",
  "payroll": "كشوف المرتبات",
  "payrollReport": "تقرير الرواتب",
  "selectMonth": "اختر الشهر",
  "select": "يختار",
  "generate": "يولد",
  "selectdate": "حدد تاريخا",
  "selecttime": "حدد الوقت",
  "remote": "بعيد",
  "office": "مكتب",
  "selectrange" : "اختر النطاق",
  "totalhours" : "إجمالي الساعات",	
  "clockin&out" : "تسجيل الدخول والخروج",
  "clockinlocation" : "موقع تسجيل الدخول",
  "clockoutlocation" : "موقع تسجيل الخروج",
  "forgetClockin&out": "ننسى على مدار الساعة في وساعة الخروج",
  "clockOutConfirm": "تأكيد انتهاء الساعة",
  "clockInConfirm": "الساعة في التأكيد",
  "AreyouwanttoClockOut": "هل أنت متأكد أنك تريد إيقاف الساعة؟",
  "AreyouwanttoClockIn": "هل أنت متأكد أنك تريد تسجيل الدخول؟",
  "forgotclckin&out": "نسيت الساعة داخل / خارج",
  "timezonechange": "تغيير المنطقة الزمنية",
  "timezone": "منطقة زمنية",
  "notes": "ملاحظات",
  "newchat": "دردشة جديدة",
  "selectTimeZone": "حدد المنطقة الزمنية",
  "home": "بيت",
  "service": "خدمة",
  "BOT": "بوت",
  "chat": "محادثة",
  "notify": "إشعار",
  "saveforlater": "حفظ لوقت لاحق",
  "Swipetoclockout": "اسحب للخروج",
  "Swipetoclockin": "اسحب لتسجيل الدخول",
  "accepted": "مقبول",
  "maybe": "ربما",
  "meetingTitle": "عنوان الاجتماع",
  "payrollSummary": "ملخص الرواتب",
  "tasks": "المهام",
  "Meetings": "الاجتماعات",
  "Smart Document": "المستند الذكي",
  "projecttask": "مهمة المشروع",
  "status": "حالة",
  "remainingdays": "الأيام المتبقية",
  "speech": "خطاب",
  "history": "تاريخ",
  "reset": "إعادة ضبط",
  "ConverttoPDF" : "تحويل إلى PDF",
  "Converting" : "جارٍ التحويل",
"DownloadPDF" : "تنزيل PDF",
"clearall" : "مسح الكل",
  "aidocumentengine": "محرك المستندات بالذكاء الاصطناعي",
  "chathistory": "تاريخ الدردشة",
  "attendance" :"حضور",
  "assigntickets" : "تعيين التذاكر",
  "enterremark" : "أدخل الملاحظة",
  "choosepriority" : "اختر الأولوية",
  "closeddate" : "تاريخ الإغلاق",
  "secondresponse" : "الرد الثاني",
  "firstresponse" : "الرد الأول",
  "closedresponse" : "الرد النهائي",
  "SLADate" : "تاريخ SLA",
  "chennaioffice" : "مكتب تشيناي",
  "DubaiOffice" : "مكتب دبي",
  "WorkForce" : "القوى العاملة",
  "employeeslist" : "قائمة الموظفين",

  
    "profile": "الملف الشخصي",
    "accounts": "الحسابات",
    "language": "اللغة",
    "signature": "التوقيع",
    "preferences": "التفضيلات",
    "aboutApp": "حول التطبيق",
    "themeMode": "وضع السمة",
    "feedbackSuggestion": "ملاحظات/اقتراح",
    "change": "تغيير",
    "remove": "إزالة",
    "viewSignature": "عرض التوقيع",
    "replaceSignature": "استبدال التوقيع",
    "clear": "مسح",
    "update": "تحديث",
    "subject": "الموضوع",
    "message": "الرسالة",
  
  

  "leave" :"غياب",
  "absent" : "إجازة",
  "onduty" : "أثناء الدوام",
  "atremote" : "عن بُعد",
  "atoffice" : "في المكتب",
  "Signed": "تم التوقيع",
  "Reviewed": "تمت المراجعة",
  "Archived": "تمت الأرشفة",
  "Announcement": "إعلان",
  "CreateAnnouncement": "إنشاء إعلان",
  "EnteremployeeID": "أدخل رقم الموظف",
  "Name": "الاسم",
    "Designation": "المسمى الوظيفي",
  "Email": "البريد الإلكتروني",
  "EnterEmployeeName": "أدخل اسم الموظف",
  "Gender": "الجنس",
  "Male": "ذكر",
  "Female": "أنثى",
  "EnterEmailAddress": "أدخل عنوان البريد الإلكتروني",
  "EnterDesignation": "أدخل المسمى الوظيفي",
  "Number": "الرقم",
  "Role": "الدور",
  "SelectRole": "اختر الدور",
  "HR": "الموارد البشرية",
  "Manager": "مدير",
  "Employee": "موظف",
  "SelectTimeZone": "اختر المنطقة الزمنية",
  "TimeZone": "المنطقة الزمنية",
  "Office": "المكتب",
  "SelectLeaveTypes": "اختر أنواع الإجازات",
  "LeaveTypes": "أنواع الإجازات",
  "Days": "أيام",
  "Reporter": "المسؤول المباشر",
  "ReportTo": "تقرير إلى",
  "SearchTeamName": "البحث عن اسم الفريق",
  "Members": "الأعضاء",
  "EditTeam": "تعديل الفريق",
  "ViewTeam": "عرض الفريق",
  "DeleteTeam": "حذف الفريق",
    "GroupName": "اسم المجموعة",
  "SelectEmployees": "اختر الموظفين",
  "NoUserFound": "لم يتم العثور على مستخدم",
  "NoUsersAreCurrentlyClockedIn": "لا يوجد مستخدمون قاموا بتسجيل الدخول حاليًا",
  "teamname": "اسم الفريق",
  "areYouSureToReject": "هل أنت متأكد أنك تريد الرفض؟",



    // warning message
    "Pleaseenterafromdate" : "الرجاء إدخال تاريخ البدء",
    "Pleaseenterareason" : "الرجاء إدخال السبب",
    "Pleaseenteratodate" : "الرجاء إدخال تاريخ الانتهاء",
    "PleaseenteraleaveType" : "الرجاء إدخال نوع الإجازة",
    "Pleaseenteratitle": "الرجاء إدخال العنوان",
    "Pleaseselectemployees": "الرجاء اختيار الموظفين",
    "Pleaseselectadate": "الرجاء تحديد التاريخ",
    "PleaseselectClockintime": "الرجاء تحديد وقت الدخول",
    "PleaseselectaClockOuttime": "الرجاء تحديد وقت الخروج",
    "Pleaseselecttimezone": "الرجاء تحديد المنطقة الزمنية",

    
    "Pleaseselectadescription": "الرجاء إدخال وصف",
    "PleaseselectprojectManager": "الرجاء تحديد مدير المشروع",
    "PleaseselectTeamMembers": "الرجاء تحديد أعضاء الفريق",
    "PleaseselectaStartdateoftheproject": "الرجاء تحديد تاريخ بدء المشروع",
    "PleaseselectaEnddateoftheproject": "الرجاء تحديد تاريخ انتهاء المشروع",
    "PleaseenterclientNameoftheproject": "الرجاء إدخال اسم العميل للمشروع",

    "PleaseEnterSerialNo": "الرجاء إدخال الرقم التسلسلي",
    "PleaseEnterProductName": "الرجاء إدخال اسم المنتج",
    "PleaseEnterProductValue": "الرجاء إدخال قيمة المنتج",

    "EnterSubject": "الرجاء إدخال الموضوع",
    "EnterContent": "الرجاء إدخال المحتوى",
    "SelectReviewer": "الرجاء اختيار المراجع",
    "SelectSignByUser": "الرجاء اختيار من يوقع",
    "SelectToUsers": "الرجاء اختيار المستخدمين",
    "SelectForType": "الرجاء اختيار النوع",

    "SelectLeaveType": "الرجاء اختيار نوع الإجازة",
    "SelectOffice": "الرجاء اختيار المكتب",
    "PleaseSelectFromDate": "الرجاء تحديد تاريخ البدء",
    "PleaseEnterReason": "الرجاء إدخال السبب",
    "EnterPublishDate": "الرجاء إدخال تاريخ النشر",
    "PleaseSelectDocument": "الرجاء تحديد المستند",


    "PleaseenteremployeeID": "الرجاء إدخال رقم الموظف",
    "Pleaseenterthename": "الرجاء إدخال الاسم",
    "Pleaseentertheposition": "الرجاء إدخال المسمى الوظيفي",
    "Pleaseenterthenumber": "الرجاء إدخال الرقم",
    "Pleaseselectthegender": "الرجاء تحديد الجنس",
    "Pleaseselecttherole": "الرجاء تحديد الدور",
    "Pleaseselecttheofficelocation": "الرجاء تحديد موقع المكتب",
    "Pleaseselectthereporter": "الرجاء تحديد المسؤول المباشر",
    "PleaseselecttheTimeZone": "الرجاء تحديد المنطقة الزمنية",
    "Pleaseselecttheleavetypes": "الرجاء تحديد أنواع الإجازات",
    "Pleaseenteremail": "الرجاء إدخال البريد الإلكتروني",
      "PleaseEnterATeamName": "الرجاء إدخال اسم الفريق",
  "PleaseSelectEmployees": "الرجاء اختيار الموظفين",
    "PleaseSelectPriority": "الرجاء اختيار الأولوية",
  "PleaseEnterRemark": "الرجاء إدخال الملاحظة",
  "PleaseEnterLink": "الرجاء إدخال الرابط",
    "pleaseEnterSubject": "الرجاء إدخال الموضوع",
  "pleaseEnterMessage": "الرجاء إدخال الرسالة"






};


export default arTranslations